<div class="overflow-hidden" [style.width.px]="containerWidthPx">
  <div
    class="flex items-center w-full relative transition-all"
    [class.justify-start]="itemsCount >= 5"
    [class.justify-center]="itemsCount < 5"
    [style.left.px]="translateLeftPx"
  >
    @for (item of items; track trackByIndex(index, item); let index = $index) {
      <div
        class="mobile-pagination"
        [class.selected]="index === selectedIndex"
        [style.color]="index === selectedIndex ? selectedColor : color"
        [style.width.px]="itemWidthPx"
      >
        •
      </div>
    }
  </div>
</div>
